import PropTypes from 'prop-types'
import styled from 'styled-components'
import BasicBar from 'components/Shared/charts/BasicBar'

const StyledWrapper = styled.div`
  display: flex;
  flex: initial;
  width: 100%;
  flex-direction: column;
  padding: 0;
  border-radius: 3px;
  background-color: #FFFFFF;
`

const ChartWrapper = styled.div`
  flex: 1;
`

const HttpRequestCodeChartBar = ({ httpRequestCodesCount }) => {
  return (
    <StyledWrapper>
      <ChartWrapper>
        <BasicBar data={httpRequestCodesCount} />
      </ChartWrapper>
    </StyledWrapper>
  )
}

HttpRequestCodeChartBar.propTypes = {
  httpRequestCodesCount: PropTypes.array,
}

export default HttpRequestCodeChartBar
